<template>
  <div :class="$style[classes]">
    <pt-page-title :title="title"></pt-page-title>
    <customer-message :data="customer" v-loading="loading"></customer-message>
    <doctor-message :data="doctor" v-loading="loading" :userId="userId"></doctor-message>
    <question-message :data="mainQuestion" :answerList="answerRecordList" v-loading="loading" :submitLoading="submitLoading" :isEdit="isEdit"></question-message>
  </div>
</template>

<script>
// 组件class前缀
import customerMessage from './customer-message'
import doctorMessage from './doctor-message'
import questionMessage from './question-message'
const prefixCls = 'pt-obs-department-detail'
export default {
  name: 'pt-obs-department-detail',
  props: {
    id: String,
    isEdit: Boolean,
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    loading: Boolean,
    submitLoading: Boolean,
    userId: String
  },
  components: {
    customerMessage,
    doctorMessage,
    questionMessage
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    title () {
      return '产科问答' + (this.isEdit ? '编辑' : '详情')
    },
    mainQuestion () {
      return this.data.mainQuestion || {}
    },
    answerRecordList () {
      return this.data.answerRecordList || []
    },
    customer () {
      let questionerInfo = (this.mainQuestion && this.mainQuestion.questionerInfo) || {}
      let questionerExtendInfo = (this.mainQuestion && this.mainQuestion.questionerExtendInfo) || {}
      return { ...questionerExtendInfo, ...questionerInfo, city: questionerExtendInfo.city } || {}
    },
    doctor () {
      let answererExtendInfo = this.mainQuestion.answererExtendInfo || {}
      let answererInfo = this.mainQuestion.answererInfo || {}
      return { ...answererExtendInfo, ...answererInfo } || {}
    },
    questionAnswer () {
      return this.data.questionAndAnswer || {}
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-obs-department-detail{
  :global{
    .message-table{
      padding: 0 20px;
    }
    .message-button-div{
      margin-top: 20px
    }
  }
}
</style>
